// Model.js
// -----------------------
// @module Case
define("BTM.SEOPriceCurrency.SEOPriceCurrency.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/SEOPriceCurrency/SuiteScript2/SEOPriceCurrency.Service.ss"
            ),
            true
        )
});
});
